var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-556 -316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74,17.53a1.942,1.942,0,0,1-1.56-.83l-1.2-1.6c0,.01-.05-.02-.07-.02H5.54C2.12,15.08,0,14.15,0,9.54v-4C0,1.33,2.57.23,4.73.04A6.753,6.753,0,0,1,5.54,0h6.4c3.62,0,5.54,1.92,5.54,5.54v4a5.747,5.747,0,0,1-.05.84c-.18,2.13-1.28,4.7-5.49,4.7h-.4L10.3,16.7A1.942,1.942,0,0,1,8.74,17.53ZM5.54,1.5q-.345,0-.66.03C2.56,1.73,1.5,3,1.5,5.54v4c0,3.43,1.06,4.04,4.04,4.04h.4a1.674,1.674,0,0,1,1.24.61l1.2,1.61a.4.4,0,0,0,.72,0l1.2-1.6a1.544,1.544,0,0,1,1.24-.62h.4c2.54,0,3.81-1.07,4-3.35a5.426,5.426,0,0,0,.04-.69v-4c0-2.79-1.25-4.04-4.04-4.04Z",
    transform: "translate(557.25 321.25)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z",
    transform: "translate(564.99 328.19)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z",
    transform: "translate(568.19 328.19)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z",
    transform: "translate(561.8 328.19)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.643,15.04a.741.741,0,0,1-.54-.23.727.727,0,0,1-.2-.61,4.682,4.682,0,0,0,.04-.66v-4c0-2.79-1.25-4.04-4.04-4.04H1.5q-.345,0-.66.03a.76.76,0,0,1-.61-.2A.762.762,0,0,1,0,4.73C.183,2.57,1.293,0,5.5,0h6.4c3.62,0,5.54,1.92,5.54,5.54v4c0,4.21-2.57,5.31-4.73,5.5ZM1.623,4h6.27c3.62,0,5.54,1.92,5.54,5.54v3.87c1.7-.42,2.5-1.67,2.5-3.87v-4c0-2.79-1.25-4.04-4.04-4.04h-6.4C3.293,1.5,2.053,2.3,1.623,4Z",
    transform: "translate(561.297 317.25)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    transform: "translate(556 316)",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMessages);
export default __webpack_public_path__ + "static/media/vuesax-outline-messages.ab52fceecaa3b58d51f402282142ceda.svg";
export { ForwardRef as ReactComponent };